import { create } from 'zustand';

import { Theme, ThemeType } from '../types/theme.type';
import { getOS } from '../utils/os.util';

const macShortcutKey = {
    icon: '⌘',
    key: 'Meta',
};
const windowsShortcutKey = {
    icon: 'Ctrl',
    key: 'Control',
};

const PRIMARY_SHORTCUT_KEY =
    getOS() === 'mac' ? macShortcutKey : windowsShortcutKey;

interface SettingsState {
    theme: Theme;
    menuCollapsed: boolean;
    menuCollapsable: boolean;
    sendOnEnter: boolean;

    collapseMenu: () => void;
    toggleMenuCollapsable: () => void;
    shortcuts: {
        displayText: string;
        keys: string[];
        action: (key: string, holdingKey?: { [key: string]: boolean }) => void;
    }[];
    initShortcuts: () => void;
    toggleSendOnEnter: () => void;
}

const useSettingsStore = create<SettingsState>((set, get) => ({
    theme: {
        current: (localStorage.getItem('theme') as ThemeType) ?? 'light',
        change: (themeValue) => {
            localStorage.setItem('theme', themeValue);
            set({ theme: { ...get().theme, current: themeValue } });
        },
    },
    menuCollapsed: false,
    menuCollapsable: true,
    sendOnEnter: localStorage.getItem('sendOnEnter') === 'true',

    collapseMenu: () => {
        set({ menuCollapsed: !get().menuCollapsed });
    },
    toggleMenuCollapsable: () =>
        set({ menuCollapsable: !get().menuCollapsable }),
    shortcuts: [
        {
            displayText: 'Crear solicitud',
            keys: [PRIMARY_SHORTCUT_KEY.icon, 'E'],
            action: (key: string, holdingKey?: { [key: string]: boolean }) => {
                if (holdingKey![PRIMARY_SHORTCUT_KEY.key] && key === 'e') {
                    window.dispatchEvent(new Event('open:createPetition'));
                }
            },
        },
        {
            displayText: 'Mostrar buscador',
            keys: [PRIMARY_SHORTCUT_KEY.icon, 'B'],
            action: (key: string, holdingKey?: { [key: string]: boolean }) => {
                if (holdingKey![PRIMARY_SHORTCUT_KEY.key] && key === 'b') {
                    window.dispatchEvent(new Event('open:search'));
                }
            },
        },
    ],
    initShortcuts: () => {
        const keyPressed: { [key: string]: boolean } = {};
        window.addEventListener('keydown', (ev) => {
            keyPressed[ev.key] = true;
            get().shortcuts.forEach((shortcut) => {
                shortcut.action(ev.key, keyPressed);
            });
        });
        window.addEventListener('keyup', (ev) => {
            delete keyPressed[ev.key];
        });
    },
    toggleSendOnEnter: () => {
        const value = !get().sendOnEnter;
        set({ sendOnEnter: value });
        localStorage.setItem('sendOnEnter', value.toString());
    },
}));

export { useSettingsStore };
